import moment from 'moment'

import 'moment/locale/pt-br'

moment.locale('pt-BR')

//
//
//

export default (data, hora, shift = false, minutes = 0) => {
  const tz = shift.dutyStartDateTZ && shift.dutyStartDateTZ === '+0000'

  //

  const dutyStartDate = (tz ? moment.utc(data) : moment(data)).format('YYYY-MM-DD')
  const dutyDate = moment(`${dutyStartDate} ${hora}:00`, 'YYYY-MM-DD HH:mm:ss').unix()

  const now = (tz ? moment.utc() : moment()).unix()

  //

  const dutyProgressStatus = shift.start_location && shift.end_location ? 'finished' : (shift.start_location ? 'started' : 'unknown')

  const range = minutes * 60

  return ((
    shift !== false &&
    (dutyProgressStatus !== 'started') &&
    (now > dutyDate) &&
    ((now - dutyDate) > range)
  ) || (
    shift === false &&
    (now > dutyDate) &&
    ((now - dutyDate) > range)
  ))
}
